// @flow
/* -----------------Globals--------------- */
import React, { useState } from 'react';

/* -----------------UI--------------- */
import {
  Menu,
  MenuItem,
  ListSubheader,
  Button,
  IconButton,
  Box,
} from '@material-ui/core';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

/* -----------------Icons--------------- */
import {
  DotsVertical,
} from 'mdi-material-ui';

/* -----------------Styles--------------- */
const styles = theme => ({
  button: {
    ...theme.overrides.MuiListSubheader.root,
    '&$hasBorder': {
      border: '1px solid',
      padding: theme.spacing(1.5),
    },
  },
  hasBorder: {},
});

/* -----------------Type declarations--------------- */
type MenuItemClickAction = (item: *) => void;

type Classes = {
  button: string,
  hasBorder: string
};

/* -----------------Props--------------- */
type Props = {
  classes: Classes,
  buttonText: string,
  handleMenuItemClick: MenuItemClickAction,
  sortOptions: string[],
  children: *,
  actionComp: ?*,
  moreMenu: ?boolean,
  startIcon: ?*,
  buttonColor: ?string,
  overflowColor: ?string,
  endIcon?: *,
  hasBorder?: boolean
};

/* -----------------Component--------------- */
const Menus = (props: Props) => {
  const {
    classes,
    handleMenuItemClick,
    buttonText,
    sortOptions,
    buttonColor,
    children,
    actionComp,
    moreMenu,
    startIcon,
    overflowColor,
    endIcon,
    hasBorder,
  } = props;
  const [showMenu, setShowMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const sortMenuId = 'primary-sort-menu';
  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowMenu(false);
  };
  const handleSortingMenu = (event) => {
    setShowMenu(true);
    setAnchorEl(event.currentTarget);
  };

  const renderSortMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={sortMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {sortOptions.map((item, index) => (
        <MenuItem
          key={index.toString()}
          onClick={() => {
            handleMenuItemClick(item);
            handleMenuClose();
          }}
        >
          {children(item)}
        </MenuItem>
      ))}
    </Menu>
  );

  if (moreMenu) {
    return (
      <>
        <IconButton onClick={handleSortingMenu} edge="end">
          <DotsVertical style={{ color: overflowColor || 'inherit' }} />
        </IconButton>
        {showMenu ? renderSortMenu : null}
      </>
    );
  }
  return (
    <ListSubheader
      disableGutters
      disableSticky
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        height={48}
        mt={hasBorder ? 2 : 0}
      >
        <Button
          color={buttonColor || 'inherit'}
          variant="text"
          startIcon={startIcon || null}
          endIcon={endIcon || null}
          aria-controls={sortMenuId}
          onClick={handleSortingMenu}
          className={clsx(classes.button, hasBorder && classes.hasBorder)}
        >
          {buttonText}
        </Button>
        {showMenu ? renderSortMenu : null}
        {showMenu && actionComp ? actionComp : null}
      </Box>
    </ListSubheader>
  );
};

export default withStyles(styles)(Menus);
